import styles from './formulario.module.css';
import { useFormularioLogica } from './formularioLogica';
import FormularioConcluido from './formularioConcluido';

export default function FormularioLayout() {
  const {
    formulario,
    campos,
    campoAtual,
    typeButton,
    currentIndex,
    respostaAtual,
    setRespostaAtual,
    setCurrentIndex,
    changeTypeButton,
    proximo,
    anterior,
    concluir,
    isCampoNumerico,
    formularioConcluido,
    codigo,
  } = useFormularioLogica(1);

  if (!formulario) {
    return <div className={styles['div_pai']}>Carregando formulário...</div>;
  }

  return (
    <>
      {formularioConcluido ? (
        <FormularioConcluido codigo={codigo} />
      ) : (
        <div
          className={styles["div_pai"]}
          style={{
            backgroundImage: `url(${campoAtual?.imagem_url || 'https://github.com/ahmedmatarif/royalImagens/blob/main/modelo%20de%20imagem%20do%20formulario.png?raw=true'})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className={styles["div_marca"]}>
            <h1 className={styles["h1_titulo"]}>Royal Sofas</h1>
          </div>

          <div className={styles["div_filho"]}>
            <h2 className={styles["h2_filho"]}>{campoAtual?.campo_nome}</h2>

            <input
              className={styles["input_filho"]}
              type={isCampoNumerico ? "number" : "text"}
              placeholder="Digite sua resposta aqui..."
              value={respostaAtual}
              onChange={(e) => {
                const v = isCampoNumerico
                  ? e.target.value.replace(/\D/g, "")
                  : e.target.value;
                setRespostaAtual(v);
              }}
            />

            <div style={{ display: "flex", gap: 10 }}>
              <button
                className={styles["btn_filho"]}
                onClick={anterior}
                disabled={currentIndex === 0}
                type="button"
              >
                Anterior
              </button>

              <button
                className={styles["btn_filho"]}
                onClick={typeButton === "Concluir" ? concluir : proximo}
                disabled={campos.length === 0}
                type="button"
              >
                {typeButton}
              </button>
            </div>

            <div className={styles["div_filho_btn_circle"]}>
              {campos.map((campo, index) => (
                <div
                  key={campo.campo_id}
                  className={`
                  ${styles["btn_filho_circle"]}
                 ${index === currentIndex ? styles["btn_filho_circle_active"] : ""}
                  `}
                  onClick={() => {
                    setCurrentIndex(index);
                    changeTypeButton(index);
                  }}
                />
              ))}
            </div>

            
          </div>


        </div>
      )}
    </>
  );
}